import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Pagination, Response } from '@ui/src';
import { anonymisationApi } from './service';

export interface AnonymisationState {
  anonymisationLogs?: any[];
  pagination?: Pagination;
  errorsList?: string;
}

const initialState: AnonymisationState = {};

export const anonymisationSlice = createSlice({
  name: 'anonymisation',
  initialState,
  reducers: {
    clearAnonymisationState: (state) => {
      state.anonymisationLogs = undefined;
      state.pagination = undefined;
      state.errorsList = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      anonymisationApi.endpoints.getAnonymisationLogs.matchPending,
      (state) => {
        state.errorsList = undefined;
      },
    );
    builder.addMatcher(
      anonymisationApi.endpoints.getAnonymisationLogs.matchRejected,
      (state, action: any) => {
        state.anonymisationLogs = undefined;
        state.pagination = undefined;

        if (action?.payload.data) {
          if (Array.isArray(action?.payload.data?.message)) {
            state.errorsList = action?.payload.data?.message
              ?.map((item: { value: string }) => item.value)
              .join('; ');
          } else {
            state.errorsList = action?.payload.data?.error;
          }
        }
      },
    );
    builder.addMatcher(
      anonymisationApi.endpoints.getAnonymisationLogs.matchFulfilled,
      (state, action: PayloadAction<Response<any>>) => {
        state.anonymisationLogs = action?.payload?.data?.edges?.map((item) => ({
          ...item.node,
        }));

        state.pagination = action.payload.data.pageInfo;
      },
    );
  },
});

export const { clearAnonymisationState } = anonymisationSlice.actions;

export default anonymisationSlice.reducer;
